import { Button } from '@kerfjs/ui/button';
import { List } from '@kerfjs/ui/list';
import { Row } from '@kerfjs/ui/row';
import { Text } from '@kerfjs/ui/text';
import type { SafeHtml } from 'kerfjs';

import type { SupplierLead } from '../lib/supplier-leads.js';
import { CurrencyAmount } from './currency-amount.js';

export function SupplierLeadList({ leads, canAdd }: { leads: SupplierLead[]; canAdd: boolean }): SafeHtml {
  return (
    <List gap="m" className="supplier-lead-list">
      {(['local', 'import'] as const).map((origin) => {
        const group = leads.filter((lead) => lead.origin === origin);
        if (group.length === 0) return null;
        return (
          <section data-supplier-origin={origin}>
            <List gap="xs">
              <Text variant="h4">{origin === 'local' ? 'Local suppliers' : 'Import suppliers'}</Text>
              {group.map((lead) => (
                <article data-supplier-lead={lead.benchmarkId}>
                  <List gap="xs">
                    <a href={lead.url} target="_blank" rel="noopener noreferrer">
                      {lead.name}
                    </a>
                    <Text tone="quiet" size="compact">
                      {lead.location} · {lead.matchQuality ?? 'Match not rated'}
                    </Text>
                    <Text size="compact">
                      Listed price: <CurrencyAmount value={lead.price} currency={lead.currency} />
                      {lead.unit === '' ? null : ` / ${lead.unit}`}
                    </Text>
                    {canAdd ? (
                      <Row>
                        <Button
                          tone="brand"
                          emphasis="secondary"
                          size="compact"
                          action="supplier-lead-add"
                          rootAttributes={{ 'data-benchmark-id': lead.benchmarkId }}
                        >
                          Add Vendor
                        </Button>
                      </Row>
                    ) : null}
                  </List>
                </article>
              ))}
            </List>
          </section>
        );
      })}
    </List>
  );
}
